import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import VehicleDetails from "./pages/vehicleDetails";
import CustomerVerification from "../common/page/customerVerification";
import LoanDetails from "./pages/loanDetails";
import PersonalDetails from "./pages/personalDetails";
import SecurityMandateDetails from "./pages/securityMandateDetails";
import Confirmation from "./pages/confirmation";
import Declaration from "./pages/declaration";
import EMandate from "./pages/eMandate";
import ErrorTechnical from "../common/page/errorEechnical";
import FinalVerifyETB from "./pages/finalVerifyETB";

const DDRoute = () => (
    <Router basename="/dd-al">
        <Switch>
            {/* <Redirect exact from="/" to="/customer-verification" /> */}
            {/* <Route
                exact
                path="/customer-verification"
                component={CustomerVerification}
            /> */}
            <Route exact path="/vehicle-details" component={VehicleDetails} />
            <Route exact path="/loan-details" component={LoanDetails} />
            <Route exact path="/personal-details" component={PersonalDetails} />
            <Route
                exact
                path="/security-mandate-details"
                component={SecurityMandateDetails}
            />
            <Route exact path="/declaration" component={Declaration} />
            <Route exact path="/final-verify" component={FinalVerifyETB} />
            <Route exact path="/confirmation" component={Confirmation} />
            <Route exact path="/e-mandate" component={EMandate} />
            <Route exact path="/error" component={ErrorTechnical} />
            <Route exact>
                <h1>404 not Found</h1>
            </Route>
        </Switch>
    </Router>
);

export default DDRoute;
